import { Stack, Typography, useTheme } from "@mui/material";
import type { FC } from "react";
import { useFormatGoalAmount } from "web_myplann/Goals/Helpers/formatGoalAmount";
import type { RentPlan } from "web_myplann/Goals/Types/RentPlan";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";

type Props = {
	plan: RentPlan;
};

export const RentTimelineYears: FC<Props> = ({ plan }) => {
	const theme = useTheme();
	const { t } = useResource();
	const formatAmount = useFormatGoalAmount();
	const accumColor = theme.palette.blue.main;
	const drawColor = theme.palette.orange.main;

	const drawdownLabel = plan.isPerpetual
		? t(Resources.Goals.Detail.RentPlan.drawdownPerpetualLabel, {
				amount: formatAmount(plan.monthlyRent, plan.currencyCode),
			})
		: t(Resources.Goals.Detail.RentPlan.drawdownToZeroLabel, {
				years: plan.drawYears,
				amount: formatAmount(plan.monthlyRent, plan.currencyCode),
			});

	return (
		<Stack direction="row" alignItems="flex-start" gap={0.5}>
			<Stack alignItems="flex-start" flexGrow={plan.accumFlex} flexBasis={0}>
				<Typography variant="hint" tabular>
					{plan.currentYear}
				</Typography>
				<Typography variant="caption" color={accumColor} tabular>
					{t(Resources.Goals.Detail.RentPlan.accumYearsLabel, {
						count: plan.accumYears,
					})}
				</Typography>
			</Stack>
			<Stack alignItems="flex-end" flexGrow={plan.drawFlex} flexBasis={0}>
				<Typography variant="hint" tabular>
					{plan.dueYear}
				</Typography>
				<Typography
					variant="caption"
					color={drawColor}
					tabular
					textAlign="right"
				>
					{drawdownLabel}
				</Typography>
			</Stack>
		</Stack>
	);
};
